module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_html.js
// module id = HAf2
// module chunks = 0